import React, { useState, useRef, useEffect } from "react";
import { DialogRoot } from "components/ui/dialog";
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Input,
} from "@chakra-ui/react";
import { Button } from "components/ui/button";
import api from "utils/apiService";
import { toast } from "react-toastify";
import Switch from "components/switch";
import PermissionsSelector from "./PermissionsSelector";
import { getDashboardRoutes } from "../utils";

const CreateAdmin = ({ refetch }) => {
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    password: "",
    enabledDashboardPaths: [],
    superAdmin: false,
  });
  const [dashboardRoutes, setDashboardRoutes] = useState([]);
  const closeRef = useRef();

  useEffect(() => {
    import("routes.js").then((mod) => {
      setDashboardRoutes(getDashboardRoutes(mod.default));
    });
  }, []);

  const handleCreate = async () => {
    const body = {
      ...formData,
      role: "admin",
      enabledDashboardPaths: formData.superAdmin
        ? []
        : formData.enabledDashboardPaths,
    };
    if (!body.name || !body.phoneNumber || !body.password) {
      return toast.error("الرجاء ملء جميع الحقول");
    }
    const res = await api.post("/users/createUser", body);
    if (res.error) {
      toast.error(res.error);
    } else {
      toast.success("تم إضافة المسؤول بنجاح");
      closeRef.current.click();
      setFormData({
        name: "",
        phoneNumber: "",
        password: "",
        enabledDashboardPaths: [],
        superAdmin: false,
      });
      if (refetch) refetch();
    }
  };

  return (
    <DialogRoot dir="rtl">
      <DialogTrigger asChild>
        <button className="my-4 rounded-md bg-blueSecondary py-2 px-4 text-white transition-all float-end hover:bg-brandLinear">
          اضافة مسؤول
        </button>
      </DialogTrigger>
      <DialogContent className="fixed top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-gray-700 end-1/2 dark:bg-navy-800 dark:text-white">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">إضافة مسؤول</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="mb-4">
            <label className="mb-2 block text-base" htmlFor="name">
              الاسم
            </label>
            <Input
              id="name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              className="w-full border p-2"
            />
          </div>
          <div className="mb-4">
            <label className="mb-2 block text-base" htmlFor="phone">
              رقم الهاتف
            </label>
            <Input
              id="phone"
              value={formData.phoneNumber}
              onChange={(e) =>
                setFormData({ ...formData, phoneNumber: e.target.value })
              }
              className="w-full border p-2"
            />
          </div>
          <div className="mb-4">
            <label className="mb-2 block text-base" htmlFor="password">
              كلمة المرور
            </label>
            <Input
              type="password"
              id="password"
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              className="w-full border p-2"
            />
          </div>
          <div className="mb-4 flex items-center gap-2">
            <Switch
              id="createSuperAdmin"
              checked={formData.superAdmin}
              onChange={(e) =>
                setFormData({ ...formData, superAdmin: e.target.checked })
              }
            />
            <label htmlFor="createSuperAdmin" className="text-base">
              مدير عام
            </label>
          </div>

          {!formData.superAdmin && (
            <div className="mb-4">
              <label className="mb-2 block text-base" htmlFor="routes">
                الصلاحيات المسموح بها
              </label>
              <PermissionsSelector
                routes={dashboardRoutes}
                selected={formData.enabledDashboardPaths}
                onChange={(paths) =>
                  setFormData((prev) => ({
                    ...prev,
                    enabledDashboardPaths: paths,
                  }))
                }
              />
            </div>
          )}
        </DialogBody>
        <DialogFooter>
          <Button onClick={handleCreate} variant="outline">
            <span>اضافة</span>
          </Button>
          <DialogActionTrigger asChild ref={closeRef}>
            <Button variant="outline">
              <span>إلغاء</span>
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};

export default CreateAdmin;
